import React from "react";

function Loadingnovel() {
  return (
    <div>
      <div className="flex justify-center items-center rectangle duration-500 ease-in-out object-cover">
        <div className="eye-parento navZoom opacity-50">
          <div className="eye-parento-4"></div>
          <div className="eye-parento-2">
            <div className="eye-parento-3"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loadingnovel;
